import script from "./UnauthenticatedCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnauthenticatedCard.vue?vue&type=script&setup=true&lang=ts"

import "./UnauthenticatedCard.vue?vue&type=style&index=0&id=a4fe55e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4fe55e4"]])

export default __exports__